module.exports = __webpack_public_path__ + "media/sidebar/internal-21b33671.svg";